'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Spinner = require('../../components/loaders/Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

var _Icon = require('../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

require('./LinkStateDisplay.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinkStateDisplay = function LinkStateDisplay(_ref) {
    var element = _ref.element;

    var fetching = !element.getIn(['content', 'link', 'url']) && element.getIn(['attachment', 'fetching']);
    var error = element.getIn(['content', 'temp', 'error']);
    var favicon = element.getIn(['content', 'link', 'favicon']);

    var displayElement = _react2.default.createElement(_Icon2.default, { name: 'link-icon' });

    if (error) {
        displayElement = _react2.default.createElement(_Icon2.default, { name: 'link-fail' });
    }

    if (fetching) {
        displayElement = _react2.default.createElement(_Spinner2.default, { show: true });
    }

    if (favicon) {
        displayElement = _react2.default.createElement('img', { src: favicon, width: '16', height: '16' });
    }

    return _react2.default.createElement(
        'div',
        { className: 'LinkStateDisplay' },
        displayElement
    );
};

LinkStateDisplay.propTypes = {
    element: _propTypes2.default.object
};

exports.default = LinkStateDisplay;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/link/LinkStateDisplay.js
// module id = 2002
// module chunks = 0